const $app = $('.app');
const $appView = $('.app__view');
const $appLnb = $('.app__lnb');
const $main = $('main');
const $dimmed = '<div class="dimmed"></div>';
const $clickTrigger = '<em class="app__pointer"><span>Click Here</span></em>';
const $keyPadNumber = $('.layered[data-layered-name=keyPadNumber]');
const $keyPadMoney = $('.app__keypad--money');
const $keyPadPassword = $('.layered[data-layered-name=keyPadPassword]');
const pageTransitionDelay = 800;

//vh 문제점(변수화)
const gfn_vhFix = function () {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', vh + 'px');
};
gfn_vhFix();

const gfn_osCheck = function () {
	let ua = navigator.userAgent.toLowerCase();
	if (ua.indexOf('android') > -1) {
		return 'android';
	} else if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('ipod') > -1) {
		return 'ios';
	} else {
		return 'other';
	}
};

const gfn_step = {
	activate: function ($target, cb) {
		let top;
		let wb_direction = $target.data('direction');
		let delay = typeof $target.data('delay') != 'number' ? 0 : $target.data('delay');
		let duration = typeof $target.data('duration') != 'number' ? 800 : $target.data('duration');
		//console.log('gfn_step.activate 스텝 활성화', '콜백:', cb, '콜백전 대기시간', delay);
		$target.addClass('is-active');

		if (!$target.hasClass('js__no-focus')) {
			//console.log(wb_direction);
			if (wb_direction == 'up') {
				top = $target.offset().top - 180;
			} else {
				top = $target.offset().top - 120;
			}
			$main.stop().delay(delay).animate({ scrollTop: top }, duration);
		}

		if (cb != undefined) cb();

		return false;
	},
	deactivate: function ($target) {
		//console.log('gfn_step.deactivate : 스텝 사라짐');
		$target.addClass('is-out');
		$target.one('animationend', function () {
			$(this).removeClass('is-out is-active');
		});
		$target.find('.app__pointer').remove();

		return false;
	},
	focusOn: function ($target) {
		//console.log('gfn_step.focusOn : 빨간점 삽입');
		if ($target.css('position') == 'static') $target.css({ position: 'relative' });

		if ($target.find('a, button').length) {
			$target.find('a, button').append($clickTrigger);
		} else if ($target.find('input').length) {
			$target.prepend($clickTrigger);
		} else {
			$target.append($clickTrigger);
		}

		return false;
	},
	focusOff: function ($target) {
		//console.log('gfn_step.focusOff : 빨간점 제거');
		if ($target != 'all') {
			$target.find('.app__pointer').remove();
		} else {
			$('.app__pointer').remove();
		}

		return false;
	},
};

const gfn_layered = {
	open: function (name, cb) {
		//console.log(name, cb);
		let $layered = $('.layered[data-layered-name=' + name + ']');
		let type = $layered.data('layered-type');

		//Already Activate
		if ($layered.hasClass('is-active')) return false;

		if (type == 'bottomSheet') {
			$($dimmed).insertBefore($layered);
			$('.dimmed').addClass('is-active');
		}
		if (type == 'keyPadNumber') $app.addClass('keypad--number');
		$layered.addClass('is-active');

		if (name == 'finalStep') {
			setTimeout(function () {
				$('.bear__wrap').addClass('is-active');
			}, 1000);
		}

		if (cb != undefined) cb();

		return false;
	},
	close: function (name, cb) {
		//console.log(name, cb);
		let $layered = $('.layered[data-layered-name=' + name + ']');
		let type = $layered.data('layered-type');

		$layered.removeClass('is-active');
		if (type == 'bottomSheet') {
			$layered.prev('.dimmed').fadeOut(400, function () {
				$(this).remove();
			});
		}

		if (type == 'keyPadNumber') $app.removeClass('keypad--number');

		if (cb != undefined) cb();

		return false;
	},
};

//시스템 숫자 키보드
let systemKey = 0;
const gfn_keypad = {
	init: function (arr, cb) {
		//init
		gfn_step.focusOff('all');
		gfn_keypad.activate($keyPadNumber.find('button[data-key="' + arr[0] + '"'));

		$keyPadNumber.on('click', 'button', function () {
			if ($(this).hasClass('is-active')) {
				systemKey++;
				let $activeKey = $keyPadNumber.find('button[data-key="' + arr[systemKey] + '"');
				gfn_keypad.input($('input.is-active'), $(this).data('key'));
				gfn_keypad.activate($activeKey);

				//console.log('다음다음다음' + arr[systemKey]);
				if (arr[systemKey] == undefined && cb != undefined) cb();
			}
		});

		return false;
	},
	input: function ($target, idx) {
		//console.log(($target, idx));
		let max = $target.attr('maxlength');
		let val = $target.val();

		if (val.length >= max) return false;

		let inputVal = String(val) + idx;
		if (inputVal.length == 12) inputVal = String(inputVal).replace(/(\d{3})(\d{3})(\d{6})/, '$1-$2-$3');

		$target.val(inputVal);

		return false;
	},
	activate: function ($this) {
		$keyPadNumber.find('.app__pointer').remove();
		$this.addClass('is-active').siblings('button').removeClass('is-active');
		gfn_step.focusOn($this);
	},
};

//금액 입력 키보드
let moneyKey = 0;
const gfn_keypadMoney = {
	init: function (arr, cb) {
		//init
		gfn_step.focusOff('all');
		gfn_keypadMoney.activate($keyPadMoney.find('button[data-key="' + arr[0] + '"'));

		$keyPadMoney.on('click', 'button', function () {
			if ($(this).hasClass('is-active')) {
				moneyKey++;
				let $activeKey = $keyPadMoney.find('button[data-key="' + arr[moneyKey] + '"');
				gfn_keypadMoney.input($('input.is-active'), $(this).data('key'));
				gfn_keypadMoney.activate($activeKey);

				//console.log('다음다음다음' + arr[moneyKey]);
				if (arr[moneyKey] == undefined && cb != undefined) cb();
			}
		});

		return false;
	},
	input: function ($target, idx) {
		//console.log(($target, idx));
		let max = $target.attr('maxlength');
		let val = $target.val();

		//max가 넘어가면 찍히지 않기
		if (val.length >= max) return false;

		//
		let inputVal = String(val) + idx;
		let amount = Number(inputVal.replace(',', ''));

		//console.log(inputVal, amount, korNum);

		//3자리 콤마를 찍어서 넣기
		inputVal = String(inputVal)
			.replace(',', '')
			.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

		$target.val(inputVal);
		$target
			.siblings('.amount--kor')
			.find('span')
			.text(inputVal + '만');

		return false;
	},
	activate: function ($this) {
		$keyPadMoney.find('.app__pointer').remove();
		$this.addClass('is-active').siblings('button').removeClass('is-active');
		gfn_step.focusOn($this);
	},
};

//비밀번호 입력 키보드
let keypadPasswordType;
let password = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
let passwordKey = 0;
const gfn_keypadPassword = {
	init: function (arr, cb) {
		//SET
		if ($keyPadPassword.data('layered-type') != 'bottomSheet') {
			//fullContent
			$keyPadPassword.find('.digit-4').remove();
			$keyPadPassword.find('.password h2').text('6자리 비밀번호를 입력해 주세요.');
			$keyPadPassword.find('.message span').html('123456 비밀번호 6자리를<br>입력해 주세요');
			keypadPasswordType = 'Digit6';
		} else {
			//bottomSheet
			$keyPadPassword.find('.digit-6').remove();
			keypadPasswordType = 'Digit4';
			$keyPadPassword.find('.message span').html('0808 비밀번호 4자리를<br>입력해 주세요');
		}

		let $keyPad = $keyPadPassword.find('.keypad');
		$keyPad.find('button').remove();
		gfn_keypadPassword.shuffle(password);

		for (let index = 0; index < password.length; index++) {
			$keyPadPassword
				.find('.keypad')
				.append(`<button type="button" data-key="${password[index]}"><span>${password[index]}</span></button>`);
		}
		//INIT
		gfn_step.focusOff('all');
		gfn_keypadPassword.activate($keyPadPassword.find('button[data-key="' + arr[0] + '"'));

		$keyPadPassword.on('click', 'button', function () {
			if ($(this).hasClass('is-active')) {
				passwordKey++;
				//비밀번호 화면
				$keyPadPassword
					.find('.password')
					.find('img[data-press=' + passwordKey + ']')
					.show();

				//6자리 2번 실행처럼 보이기
				if (passwordKey == 6 && keypadPasswordType == 'Digit6') {
					$keyPadPassword.find('.password h2').text('비밀번호를 다시 입력해 주세요.');
					$keyPadPassword.find('.password img').removeAttr('style');
					$keyPadPassword.find('.message span').html('123456 비밀번호 6자리를<br>재입력해 주세요');
				}

				let $activeKey = $keyPadPassword.find('button[data-key="' + arr[passwordKey] + '"');
				gfn_keypadPassword.activate($activeKey);

				if (arr[passwordKey] == undefined && cb != undefined) cb();
			}
		});

		return false;
	},
	activate: function ($this) {
		$keyPadPassword.find('.app__pointer').remove();
		$this.addClass('is-active').siblings('button').removeClass('is-active');
		gfn_step.focusOn($this);
	},
	shuffle: function (arr) {
		arr.sort(() => Math.random() - 0.5);
	},
};

//focus 요소 화면 맞춤
const gfn_screen = {
	focusOn: function ($this) {
		let top = $this.offset().top - 56;
		//console.log(top);
		$main.stop().animate({ scrollTop: top }, 400);
	},
};

//전체메뉴
const gfn_lnb = {
	open: function () {
		$($dimmed).insertBefore($appLnb);
		$('.dimmed').addClass('is-active');
		$appLnb.addClass('is-active');
	},
	close: function () {
		$appLnb.removeClass('is-active');
		$appLnb.prev('.dimmed').fadeOut(400, function () {
			$(this).remove();
		});
	},
};

$(document)
	.on('click', '.app__header .btn-menu', function () {
		gfn_lnb.open();
	})
	.on('click', 'a', function (e) {
		let destination = $(this).attr('href');
		if (destination != 'javascript:;') {
			e.preventDefault();
			setTimeout(function () {
				window.location.href = destination;
			}, pageTransitionDelay);
		}
	})
	.on('click', '.app__lnb .btn-close, .dimmed', function () {
		gfn_lnb.close();
	})
	.on('click', 'a[data-call-layered], button[data-call-layered]', function () {
		let layeredName = $(this).data('call-layered');
		gfn_layered.open(layeredName);
	})
	.on('click', '.layered > .btn-close', function () {
		let layeredName = $(this).parent('.layered').attr('data-layered-name');
		gfn_layered.close(layeredName);
	})
	.on('click', '.layered .js-close-layered', function () {
		let layeredName = $(this).parents('.layered').attr('data-layered-name');
		gfn_layered.close(layeredName);
	});

//window init
$(window).on('load', function () {
	let hashName = window.location.hash.replace('#', '');
	if ($('.layered[data-layered-name="' + hashName + '"').length) gfn_layered.open(hashName);
});

//아라비안숫자 - > 한글
//숫자 한글로 변환
const textArray = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구', '십'];
const priceArray = ['', '십', '백', '천', '', '십', '백', '천', '', '십', '백', '천', '', '십', '백', '천'];

const numberTransformKorean = (number) => {
	//const enteredNumber = (number * 10000).toString(); // 만원 단위로 입력받기 때문에 * 10000
	const enteredNumber = number.toString();
	const numberArray = enteredNumber.split(''); //number 를 배열로 변환
	let result = ''; // 리턴값 선언
	numberArray.forEach((item, index) => {
		let numberUnit = '';
		let transNumber = textArray[enteredNumber.charAt(numberArray.length - (index + 1))]; //숫자를 해당 자리에 맞는 한글로 변환

		if (transNumber !== '') {
			numberUnit += transNumber + priceArray[index]; // 변환한 숫자가 존재할경우 자릿수를 붙여줍니다.
		}
		//단위 붙여주기
		switch (index) {
			case 4:
				numberUnit += '만';
				break;
			case 8:
				numberUnit += '억';
				break;
			case 12:
				numberUnit += '조';
				break;
		}
		// numberUnit이 존재할때 리턴값에 numberUnit을 더해줌
		if (numberUnit != '') {
			result = numberUnit + result;
		}
	});

	//0만을 사용해 억단위로 올라갈 때에 '만' 을 제거해준다
	const zeroCount = numberArray.filter((item) => item === '0').length;
	if (zeroCount === 8) {
		result = result.replace('만', '');
	}

	return result;
};
